
export const TabsEstilo = 
    {   
        pestaniasContenedor: "ptur-multitabProfile-pestaniasContenedor bgc-grey95", 
        pestanias: "ptur-multitabProfile-pestanias",
        usarHover: "ptur-multitabProfile-usarHover",
        flecha: "ptur-multiabProfile-flecha",
        flechaContTitulo: "ptur-multiabProfile-flecha-contTitulo",
        datosPersonales: "ptur-multitabProfile-pestania-datosPersonales",
        obraSoc: "ptur-multitabProfile-pestania-obraSoc",
        bgc: "bgc-latex10",
        colorClaro: "c-white",
        colorOscuro: "c-black10",
        tipoTexto: "rb18m"  
    };
  